<template>
    <div id="Remind">
        <b-modal id="remModal" @hide="onHide(false)">
            <b-row class="text-center">
                <b-col>
                    <h4>{{$t('FGT_PWD')}}</h4>
                    <b-form-input
                            id="remPwdId"
                            v-model="$v.login.$model"
                            :state="validateState('login')"
                    ></b-form-input>
                </b-col>
                <b-col>
                    <h4>{{$t('FGT_LOGIN')}}</h4>
                    <b-form-input
                            id="remLoginId"
                            v-model="$v.email.$model"
                            :state="validateState('email')"
                    ></b-form-input>
                </b-col>
            </b-row>
            <br>
            <b-row class="text-center m-2" v-for="i in numbers" v-bind:key="i">
                <b-col v-for="j in numbers" v-bind:key="j">
                    <b-img :src="captPath+i+j+'.jpg'"></b-img>
                </b-col>
            </b-row>
            <b-row class="text-center">
                <b-col>
                    <br>
                    <h4>{{$t('ENTER_NUM')}}</h4>
                    <br>
                </b-col>
            </b-row>
            <b-row class="text-center">
                <b-col>
                    <h4>{{$t('T_CATS')}}</h4>
                    <b-form-input
                        id="remLoginId1"
                        v-model="$v.code1.$model"
                        :state="validateState('code1')"
                        style="width:12rem;display:inline-block"
                    ></b-form-input>
                </b-col>
            <b-col>
                <h4>{{$t('T_DOGS')}}</h4>
                <b-form-input
                        id="remLoginId2"
                        v-model="$v.code2.$model"
                        :state="validateState('code2')"
                        style="width:12rem;display:inline-block"
                ></b-form-input>
            </b-col>
            <b-col>
                <h4>{{$t('T_FLOWERS')}}</h4>
                <b-form-input
                        id="remLoginId3"
                        v-model="$v.code3.$model"
                        :state="validateState('code3')"
                        style="width:12rem;display:inline-block"
                ></b-form-input>
            </b-col>
            </b-row>
            <template v-slot:modal-footer="{}">
                <b-button size="md" variant="warning" @click="$bvModal.hide('remModal')">
                    {{$t('CLOSE')}}
                </b-button>
                    <b-button size="md" variant="success" @click="checkCode()">
                        {{$t('SEND')}}
                    </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { BRow, BCol, BFormInput, BModal, BImg, BButton } from 'bootstrap-vue';
import { validationMixin } from "vuelidate";
import { required, requiredUnless, numeric, minValue, maxValue, minLength, maxLength, email } from 'vuelidate/lib/validators';

export default {
    name: 'Remind',
    components: {
        BRow, BCol, BFormInput, BModal, BImg, BButton
    },
    mixins: [validationMixin],
    props: {
        //userName: String
    },
    data: function() {
        return {
            login: '',
            email: '',
            captName: '',
            captPath: '',
            numbers: [0,1,2],
            code1: '',
            code2: '',
            code3: ''
        }
    },
    mounted() {
        //alert(this.$store.state.intLoc);
        this.$bvModal.show('remModal');
        this.genCapt();
    },
    methods: {
    validateState(name) {
        const { $dirty, $error } = this.$v[name];
        return $dirty ? !$error : null;
    },
    async genCapt() {
        try {
            const response = await this.$http.get('genCapt');
            this.captName = await response.data;
            this.captPath = 'data/codes/'+this.captName;
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async checkCode() {
        this.$v.$touch();
        if(this.$v.$anyError) return;
        try {
            //alert(this.code1+''+this.code2+''+this.code3);
            await this.$http.get('remind', {
                params: {
                    userName: this.login,
                    userEmail: this.email,
                    captcha: this.code1+''+this.code2+''+this.code3,
                    fName: this.captName.substring(0,4)
                }
            });
            this.onHide(true);
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async resendCode() {
        try {
            await this.$http.get('resendCode');
            this.$showMsg(this.$t('DONE'));
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    onHide(state) {
        this.$emit('reminded', state);
    },
  },
    validations: {
        code1: {
            required,
            numeric,
            minValue: minValue(0),
            maxValue: maxValue(9)
        },
        code2: {
            required,
            numeric,
            minValue: minValue(0),
            maxValue: maxValue(9)
        },
        code3: {
            required,
            numeric,
            minValue: minValue(0),
            maxValue: maxValue(9)
        },
        login: {
            requiredUnless: requiredUnless(function () { return this.email!='' }),
            minLength: minLength(2),
            maxLength: maxLength(24)
        },
        email: {
            requiredUnless: requiredUnless(function () { return this.login!='' }),
            email,
            maxLength: maxLength(24)
        }
    }

}
</script>